import Vue from 'vue';

const success = (context, response) => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal(context.$t('rentals.detail.modals.deleted_success'), context.$t('rentals.detail.modals.deleted_success'), "success");
  context.loading = false;
  Vue.router.push({
    name: 'rentals.index',
  });
};

const failed = (context, error) => {
  if (error && error.response && error.response.data && error.response.data.msg) {
    $(".cancel").removeClass("disabled");
    $(".confirm").removeClass("disabled");
    swal("Error!", error.response.data.msg, "warning");
    toastr.error(error.response.data.msg);
    context.loading = false;

    if (error && error.response && error.response.data && error.response.data.beds24Error) {
      context.removeRentalFromOurSide(error.response.data.msg);
    }
  }
};

export default (context, id) => {
  return Vue.$http.delete(`/rentals/${id}/all`)
    .then(response => {
      if (response && response.status === 200) {
        success(context, response.data);
      }
    }).catch(error => {
      failed(context, error);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/rental/removeWithBookings.js